import { Link } from "react-router-dom";
// import styles from "./Nav.module.css";
import StyledNav from "./Navbar.Module";




function Nav() {
  return (
     <StyledNav>
        {/* <div className={styles.container}> */}
        <nav >
                   <div>
                       <h2 >Covid ID</h2>
                   </div>

                   <div>
                       <ul >
                        {/* Membuat react-router */}
                           <li>
                                <Link className="navbar__color" to="/">Home</Link>
                           </li>
                           <li>
                                <Link className="navbar__color" to="/component/global">Global</Link>
                           </li>
                           <li>
                                <Link className="navbar__color" to="/component/indonesia">Indonesia</Link>
                           </li>
                           <li >
                                <Link className="navbar__color" to="/component/provinces">Provinsi</Link>
                          </li>
                           <li >
                                <Link className="navbar__color" to="/component/about">About</Link>
                           </li>
                       </ul>
                   </div>
        </nav>


    
    {/* </div> */}
     </StyledNav>
    
  );
}

export default Nav;
